<template>
    <div :class="classes">
        <div class="card" @click="onClick">
            <div class="card-body">
                <slot></slot>
            </div>
        </div>
        <slot name="modal"></slot>
    </div>
</template>

<script>
export default {
  name: 'DefaultPanel',
  props: {
    title: String,
    isSelected: {
      type: Boolean,
      default: false
    },
    minimize: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function () {
      let ret = 'template-panel'
      if (this.isSelected) ret += ' selected'
      return ret
    }
  },
  methods: {
    onClick: function () {
      this.$emit('click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/templates/DefaultPanel.vue